const durationHelper = duration => {
  const minutes = Math.floor(duration / 60);
  const seconds = duration - 60 * minutes;
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

export default durationHelper;
